
import React from "react";
import './eventgallery.css';
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { communityimage, foodprepare, foodservice, dramaskits, exhibition, sseImages, centerEvents } from '../../data/data';

function EventGallery() {

    const communityImages = communityimage;
    const foodPrepareImages = foodprepare;
    const foodServiceImages = foodservice;
    const skitImages = dramaskits;
    const exhibitionImages = exhibition;
    const ctrevents = centerEvents
    return (
            <section id="collection-1602">
                <div className="cs-container">
                    <div className="cs-content">
                        <h2 className="cs-title">Event Gallery</h2>
                    </div>
                    <div className="cs-listing-wrapper">
                        <div className="cs-listing" data-category="one">
                            <div className="cs-item">
                                <div className="cs-picture-group">
                                    <ImageGallery items={communityImages} />
                                </div>
                            </div>
                            <div>&nbsp;&nbsp;</div>
                            <div className="cs-item">
                                    <div className="cs-picture-group">
                                        <ImageGallery items={sseImages} />
                                    </div>
                            </div>
                            <div>&nbsp;&nbsp;</div>
                            <div className="cs-item">
                                <div className="cs-picture-group">
                                    <ImageGallery items={foodPrepareImages} />
                                </div>
                            </div>
                            <div>&nbsp;&nbsp;</div>
                            <div className="cs-item">
                                    <div className="cs-picture-group">
                                        <ImageGallery items={foodServiceImages} />        
                                    </div>
                            </div>
                            <div>&nbsp;&nbsp;</div>
                            <div className="cs-item">
                                    <div className="cs-picture-group">
                                        <ImageGallery items={skitImages} />
                                    </div>
                            </div>
                            <div>&nbsp;&nbsp;</div>
                            <div className="cs-item">
                                    <div className="cs-picture-group">
                                        <ImageGallery items={exhibitionImages} />
                                    </div>
                            </div>
                            <div>&nbsp;&nbsp;</div>
                            <div className="cs-item">
                                    <div className="cs-picture-group">
                                        <ImageGallery items={ctrevents} />
                                    </div>
                            </div>
                            <div>&nbsp;&nbsp;</div>
                        </div>
                    </div>
                </div>
            </section>
    );
    }

export default EventGallery;